var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"tb-disclaimers"},_vm._l((_vm.enabledDisclaimers),function(d,i){return _c('div',{key:i,attrs:{"data-type":d.type}},[_c('dt',{domProps:{"innerHTML":_vm._s(d.key)}}),_c('dd',{domProps:{"innerHTML":_vm._s(d.text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }